import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import SimpleImageLoader from '../../Atoms/SimpleImageLoader';
import StyledBadge from '../../Atoms/SimpleStyledBadge';
import Typography from '@material-ui/core/Typography';
import UserList from '../../Atoms/UserList';

export interface IChannelReviewProps {
    name: string;
    imageURL: string;
    fetchUsersFromGroup: Function;
    // combinedUsers: any[];
    distinctUsers: any[];
    users_loading: boolean;
}

export default function ChannelReview(props: IChannelReviewProps) {
    const { distinctUsers, imageURL, name, users_loading } = props;

    return (
        <Grid container spacing={3}>
            <Grid container direction="column" item sm={6} spacing={3} xs={12}>
                <Typography component="h5" variant="h6">
                    Channel name:
                </Typography>
                <Typography component="p" paragraph={true} variant="body1">
                    {name}
                </Typography>
                {imageURL && <SimpleImageLoader alt="Channel background" src={imageURL} width={300} />}
            </Grid>
            <Grid
                alignItems="center"
                className={'selected-users-panel'}
                container
                data-cy="channels-create-selected-users-panel"
                direction="column"
                item
                sm={6}
                xs={12}
            >
                <StyledBadge badgeContent={distinctUsers.length} color="secondary" max={10000}>
                    <Typography component="h5" variant="h6">
                        Selected users:
                    </Typography>
                </StyledBadge>
                {distinctUsers.length === 0 && (
                    <Typography variant="body2">
                        All active users for this event will be added to the channel.
                    </Typography>
                )}
                {users_loading && <CircularProgress color="secondary" />}
                {!users_loading && <UserList editable={false} id="ChannelReview" users={distinctUsers} />}
            </Grid>
        </Grid>
    );
}
